module.exports = __webpack_public_path__ + "static/media/downArrowWhite3.64890c14.svg";